import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    CircularProgress,
} from '@mui/material';
import { ChangelogData, fetchChangelog } from '@src/helpers';
import Version from '@src/utilities/version';

const Changelog: React.FC = () => {
    const [open, setOpen] = useState(false);
    const [changelogData, setChangelogData] = useState<ChangelogData | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const currentVersion = Version.getVersion();

    useEffect(() => {
        const lastSeenVersion = localStorage.getItem('lastSeenVersion');
        if (lastSeenVersion !== currentVersion) {
            setOpen(true);
            localStorage.setItem('lastSeenVersion', currentVersion);

            // Fetch the changelog data
            fetchChangelog()
                .then(data => {
                    setChangelogData(data);
                    setLoading(false);
                })
                .catch(err => {
                    setError(`Failed to load changelog: ${err.message}`);
                    setLoading(false);
                });
        }
    }, [currentVersion]);

    if (!open) return null;

    return (
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
            {loading ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <CircularProgress />
                    <Typography variant="body2">Loading changelog...</Typography>
                </div>
            ) : error ? (
                <DialogContent>
                    <Typography color="error">{error}</Typography>
                </DialogContent>
            ) : (
                changelogData && (
                    <>
                        <DialogTitle>
                            <Typography variant="h5">What's New in {changelogData.version}</Typography>
                            <Typography variant="subtitle1">{changelogData.date}</Typography>
                        </DialogTitle>
                        <DialogContent dividers>
                            {/* Render sections dynamically */}
                            {Object.entries(changelogData.changelog).map(([sectionKey, sections]) => (
                                <div key={sectionKey}>
                                    <Typography variant="h6" gutterBottom>
                                        {sectionKey[0].toUpperCase() + sectionKey.slice(1)}
                                    </Typography>
                                    {sections.map((section, index) => (
                                        <div key={index} style={{ marginBottom: '10px' }}>
                                            <Typography variant="subtitle1">{section.title}</Typography>
                                            <ul>
                                                {section.details.map((detail, i) => (
                                                    <li key={i}>
                                                        <Typography variant="body2">{detail}</Typography>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            {/* <Button
                                color="primary"
                                variant="outlined"
                                onClick={() => window.open(changelogData.fullChangelogUrl, '_blank')}
                            >
                                View Full Changelog
                            </Button> */}
                            <Button color="error" variant="contained" onClick={() => setOpen(false)}>
                                Close
                            </Button>
                        </DialogActions>
                    </>
                )
            )}
        </Dialog>
    );
};

export default Changelog;
